import React from 'react';
import { AlertTriangle } from 'lucide-react';

const ConfirmModal = ({
  open,
  title,
  message,
  onCancel,
  onConfirm,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--color-overlay)] backdrop-blur-sm p-4">
      <div className="elevated-card rounded-xl shadow-2xl max-w-md w-full p-6">
        <div className="flex flex-col items-center text-center">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-4 ${destructive ? 'bg-red-500/15' : 'bg-amber-500/15'}`}>
            <AlertTriangle className={`w-6 h-6 ${destructive ? 'text-[var(--color-danger)]' : 'text-[var(--color-warning)]'}`} />
          </div>
          <h2 className="text-lg font-bold text-[var(--color-text)] mb-2">{title}</h2>
          <p className="text-[var(--color-text-secondary)] mb-6 leading-relaxed">{message}</p>
          <div className="flex w-full gap-3">
            <button
              type="button"
              onClick={onCancel}
              className="flex-1 px-4 py-2.5 rounded-lg border border-[var(--color-border)] text-[var(--color-text-secondary)] font-semibold hover:bg-[var(--color-surface-muted)] transition-colors"
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className={`flex-1 px-4 py-2.5 rounded-lg text-[var(--color-text-inverse)] font-semibold transition-colors ${
                destructive
                  ? 'bg-[var(--color-danger)] hover:opacity-90'
                  : 'brand-gradient-btn'
              }`}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
